<div pTooltip="No data points selected." showDelay="1000"
     hideDelay="500" [tooltipDisabled]="selectedDataPoints.length">
    <button pButton class="p-button-raised p-button-text cbms-button" (click)="showWatchDataDialog()"
            [disabled]="!selectedDataPoints.length || selectedDataPoints.length > 100"
            pTooltip="Watch live values of the selected datapoints" showDelay="1000" hideDelay="500">
        <mat-icon svgIcon="watch"></mat-icon>
        Watch
    </button>
</div>
